import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { TableData } from '@framework/ui/components/table/TableData.tsx';
import { type ColumnType } from 'antd/es/table';
import styled from 'styled-components';
import { CommunicationAdvancedSearch } from '../advanced-search/CommunicationAdvancedSearch.tsx';
import { type CommunicationListProps } from '../CommunicationList.tsx';
import { CommunicationTableExpandedRow } from './CommunicationTableExpandedRow.tsx';

const BackofficeTableWrapper = styled.div`
  &.is-backoffice {
    margin: 0 -24px;
    &:first-child {
      // se è il primo elemento della pagina, adeguiamo il margine superiore
      margin-top: -24px;
    }
  }
`;

interface ICommunicationTableProps extends CommunicationListProps {
  columns: Array<ColumnType<ComunicazioneDTO>>;
}

/**
 * Elenco delle comunicazioni con paginazione
 */
export function CommunicationTable(props: ICommunicationTableProps) {
  const {
    communications,
    query,
    setQuery,
    defaultQuery,
    total,
    columns,
    isBackoffice,
  } = props;

  return (
    <BackofficeTableWrapper className={'is-backoffice'}>
      <TableData
        title={() => (
          <CommunicationAdvancedSearch
            query={query}
            defaultQuery={defaultQuery}
            setQuery={setQuery}
            total={total}
            isBackoffice={isBackoffice}
          />
        )}
        darkTitleBar={false}
        uppercaseThead
        removeShadow
        rowKey="id"
        columns={columns}
        dataSource={communications}
        pagination={false}
        expandable={{
          columnTitle: <span className="sr-only">Espandi Riga</span>,
          expandedRowClassName: () => 'expanded-row-white-background',
          expandedRowRender: record => (
            <CommunicationTableExpandedRow communication={record} />
          ),
        }}
      />
    </BackofficeTableWrapper>
  );
}
